import { SelectorClaseTramites } from "../../../../bpm/config/Componentes/SelectorClaseTramites";
import { SelectorTramites } from "../../../../bpm/config/Componentes/SelectorTramites";
import { ListEmployee } from "../../../../contract/FlowHiring/ListEmployee";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../../theme/Input/InputDate";
import { useCreditCampaign } from "./useCreditCampaign";
import { SelectPolicy } from "../Policy/SelectPolicy.component";
import { InputMoney } from "../../../../theme/Input/InputMoney";


export const CreditCanpaign = () => {
    const {
        bean,
        setBean,
        lista,
        modal,
        modalConfirm,
        modalComite,
        setModal,
        setModalConfirm,
        setModalComite,
        single,
        eliminarItem,
        iconButtonsItem,
        head,
        setRowBean,
        updateItem,
        listausers,
        procedureType,
        setProcedureType,
        procedureType2,
        setProcedureType2,
        stateCampaing
    } = useCreditCampaign();

    const listaBotones = () => {
        const botones = [
            { titulo: "Editar", icono: "ri-file-list-line", visible: single.canEdit(), evento: () => { setModal({ ...modal, view: true, name: `Editar ${bean.Name}` }) } },
            { titulo: "Comite Aprobación", icono: "ri-file-list-line", visible: single.canEdit(), evento: () => { setModalComite({ ...modalComite, view: true, name: "Editar" }) } },
            { titulo: "Eliminar", icono: "ri-file-user-line", visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, view: true }) } },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const roles = [
        { id: 1, name: 'Director' },
        { id: 2, name: 'Jefe Financiero' },
        { id: 3, name: 'Jefe Presupuesto' },
        { id: 4, name: 'Ordenador del gasto' }
    ]

    const updateEmployee = (e: any) => {

        setBean({ ...bean, "ApprovalUser": JSON.stringify(e) })
    }

    return (
        <>
            <BasicPage titulo="Campaña de Credito">
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean} />
                    </div>
                </div>
            </BasicPage>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modalComite} updateModal={setModalComite} eventModal={updateItem}>
                <div className="row">
                    <div className="col">
                        <ListEmployee key={bean.IDCreditCampaign}
                            listP={bean.ApprovalUser}
                            listRoles={listausers}
                            updateLista={updateEmployee}></ListEmployee>
                    </div>
                    {/* <BasicButton eventClick={mostrar} icon=""></BasicButton> */}
                </div>
            </Modal>
            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-4">
                        <label >Nombre</label>
                        <input type="text" className="form-control " value={bean.Name} onChange={(e) => { setBean({ ...bean, ['Name']: e.target.value }) }} />
                    </div>
                    <div className="col-md-4">
                        <InputMoney _label="Valor estimado" onChange={(e: any) => { setBean({ ...bean, 'BudgetValue': e }) }} _value={bean.BudgetValue} />
                    </div>
                    <div className="col-md-4">
                        <label >Estado Campaña</label>
                        <select name="stateCampaing" className="form-select" value={bean.StateCampaing ?? undefined} onChange={(e) => { setBean({ ...bean, 'StateCampaing': parseInt(e.target.value) }) }} >
                            {stateCampaing.map((item: any, index: number) => {
                                return (
                                    <option key={index} value={item.id}>{item.name}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }}></textarea>
                    </div>
                    <div className="col-md-6">
                        <InputDate label='Fecha inicial' name='fecha inicial' value={bean.InitDate} setDate={(e: any) => { setBean({ ...bean, "InitDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate label='Fecha final' name='fecha final' value={bean.EndDate} setDate={(e: any) => { setBean({ ...bean, "EndDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Rango de cuotas</label>
                        <input type="string" className="form-control" value={bean.QuotaRange} onChange={(e) => { setBean({ ...bean, ['QuotaRange']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Escala  de valores</label>
                        <input type="number" className="form-control" value={bean.ScaleValue} onChange={(e) => { setBean({ ...bean, ['ScaleValue']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Valor minimo a prestar</label>
                        <InputMoney _label=" " onChange={(e: any) => { setBean({ ...bean, 'MinVal': parseInt(e) }) }} _value={bean.MinVal} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Valor maximo a prestar</label>
                        <InputMoney _label=" " onChange={(e: any) => { setBean({ ...bean, 'MaxVal': parseInt(e) }) }} _value={bean.MaxVal} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Valor de la tasa de interes <small>(Mensual)</small></label>
                        <input type="number" className="form-control" value={bean.RateValue} onChange={(e) => { setBean({ ...bean, ['RateValue']: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Uso de campaña:</label>
                        <select className="form-control mt-2" value={bean.TypeCampaign} onChange={(e: any) => { setBean({ ...bean, "TypeCampaign": parseInt(e.target.value) }) }}>
                            <option value={undefined}>...</option>
                            <option value={0}>Todo</option>
                            <option value={1}>Credito</option>
                            <option value={2}>Convenio</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <SelectPolicy idSelector={bean.IDPolicy} onChange={(e) => { setBean({ ...bean, "IDPolicy": e }) }} titulo="Politica a aplicar:"></SelectPolicy>
                    </div>
                    {bean.TypeCampaign >= 0 &&
                        <>
                            <div className="row">
                                {(bean.TypeCampaign == 1 || bean.TypeCampaign == 0) &&
                                    <>
                                        <hr className="mt-4" />
                                        <div className="d-flex justify-content-center">
                                            <h4>Configuracion de Credito</h4>
                                        </div>
                                        <div className="col-md-6">
                                            <SelectorTramites titulo="Clase de tramites para credito" idSelector={procedureType} onChange={(e: any) => { setProcedureType(e) }} />
                                        </div>
                                        <div className="col-md-6">
                                            <SelectorClaseTramites titulo="Procedimiento de credito" idProcess={procedureType} idSelector={bean.IDProcedureCredit} onChange={(e: any) => { setBean({ ...bean, "IDProcedureCredit": e }) }} />
                                        </div>
                                    </>
                                }
                                {(bean.TypeCampaign == 2 || bean.TypeCampaign == 0) &&
                                    <>
                                        <hr className="mt-4" />
                                        <div className="d-flex justify-content-center">
                                            <h4>Configuracion de Tienda</h4>
                                        </div>
                                        <div className="col-md-6">
                                            <SelectorTramites titulo="Clase de tramites para tienda" idSelector={procedureType2} onChange={(e: any) => { setProcedureType2(e) }} />
                                        </div>
                                        <div className="col-md-6">
                                            <SelectorClaseTramites titulo="Procedimiento de tienda" idProcess={procedureType2} idSelector={bean.IDProcedureShop} onChange={(e: any) => { setBean({ ...bean, "IDProcedureShop": e }) }} />
                                        </div>
                                    </>
                                }
                            </div>
                        </>

                    }
                </div>
            </Modal >

        </>
    );
};
